import React, { ReactNode } from 'react';
import { useSelector } from 'react-redux';
import { useMatch } from 'react-router-dom';
import styles from './BaseLayout.module.scss';
import AdminSidebar from '../AdminSidebar/AdminSidebar';
import AdminService from '../../services/AdminService';
import AuthSelectors from '../../../selectors/AuthSelectors';
import { cx } from '@emotion/css';

type BaseLayoutProps = {
    children?: ReactNode;
};

export default function BaseLayout(props: BaseLayoutProps) {
    const { children } = props;
    const isAdmin = useSelector(AuthSelectors.isAdmin);
    const adminRouteMatch = useMatch('admin/*');
    const showAdminSidebar =
        isAdmin && AdminService.isAdminAllowed() && adminRouteMatch !== null;

    return (
        <div className={cx(styles.layout, showAdminSidebar && styles.admin)}>
            {showAdminSidebar && <AdminSidebar />}
            <div className={styles.content}>{children}</div>
        </div>
    );
}
